module.exports = __webpack_public_path__ + "static/img/6.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/sp/6.png
// module id = Vx6v
// module chunks = 0